$(document).ready(function(){

    $('.filter-icon').on('click', function(){
       $('.collection-filter').addClass('active');
    })

    $('.filter-close').on('click', function(){
       $('.collection-filter').removeClass('active');
    })


    // sort filter 
    $('.select_sort').on('change', function(){
        var sort = $(this).val();
        var coll = $('.collection_name').val();

        if( coll == 'products') {
            coll = 'all'
        } else {
            coll = $('.collection_name').val();
        }
        var option_name = '';
        $(".filter-item-checkbox:checked").each(function(index, element){
            if(index !== (length -1 )) {
                option_name += $(this).data('option') + '=';
                option_name += $(this).val() + '&';
            } else {
                option_name += $(this).data('option') + '=';
                option_name += $(this).val();
            }
        });
        if(option_name !='') {
            var url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort; 
            var filter_url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort;
            window.history.pushState({}, null, filter_url);
            filter_update(url);
        }else{
            var url = '/collections/' + coll + '?sort_by=' + sort; 
            var filter_url = '/collections/' + coll + '?sort_by=' + sort;
            window.history.pushState({}, null, filter_url);
            filter_update(url);
        }
        
    });
});

function sortCheck(e, el) {
    var sort = $(el).val();
    var coll = $('.collection_name').val();

    if( coll == 'products') {
        coll = 'all'
    } else {
        coll = $('.collection_name').val();
    }
    var option_name = '';
    $(".filter-item-checkbox:checked").each(function(index, element){
        if(index !== (length -1 )) {
            option_name += $(this).data('option') + '=';
            option_name += $(this).val() + '&';
        } else {
            option_name += $(this).data('option') + '=';
            option_name += $(this).val();
        }
    });
    if(option_name !='') {
        var url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort; 
        var filter_url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort;
        window.history.pushState({}, null, filter_url);
        filter_update(url);
    }else{
        var url = '/collections/' + coll + '?sort_by=' + sort; 
        var filter_url = '/collections/' + coll + '?sort_by=' + sort;
        window.history.pushState({}, null, filter_url);
        filter_update(url);
    }
}

// function filterCheck(){
//     var option_name = '';
//     var length = $('.filter-item-checkbox:checked').length;
//     var sort = $('.select_sort').val();
//     var coll = $('.collection_name').val();

//     if( coll == 'products') {
//         coll = 'all'
//     } else {
//         coll = $('.collection_name').val();
//     }

//     $(".filter-item-checkbox:checked").each(function(index, element){
//         if(index !== (length -1 )) {
//             option_name += $(this).data('option') + '=';
//             option_name += $(this).val() + '&';
//         } else {
//             option_name += $(this).data('option') + '=';
//             option_name += $(this).val();
//         }
//     });

//     $('.added_filter').text(length);

//     if(option_name !='') {
//         var url = '/collections/' + coll + '?' + option_name + '&sort_by=' + sort; 
//         var filter_url = coll + '?' + option_name + '&sort_by=' + sort
//         window.history.pushState({}, null, filter_url);
//         filter_update(url);
//     }else{
//         var url = '/collections/' + coll + '?sort_by=' + sort; 
//         var filter_url = coll + '?sort_by=' + sort
//         window.history.pushState({}, null, filter_url);
//         filter_update(url);
//     }
// }

// function filter_update(url){
//     fetch(url)
//     .then(response => response.text())
//     .then(infoData => {
//         var products = $(infoData);
//         var items = $('.collection-product-wrap' , products);
//         // var filters = $('.collection-filter' , products);
//         $('.collection-product-wrap').replaceWith(items);
//         // $('.collection-filter').replaceWith(filters);
//     });
// }

function filterCheck() {
    var length = $('.filter-item-checkbox:checked').length;
    var sort = $('.select_sort').val();
    var coll = $('.collection_name').val();

    // Generate option_name using map() and join()
    var option_name = $('.filter-item-checkbox:checked').map(function () {
        return $(this).data('option') + '=' + $(this).val();
    }).get().join('&');

    $('.added_filter').text(length);

    // Construct URLs dynamically
    var base_url = '/collections/' + coll + '?';
    var url = base_url + (option_name ? option_name + '&' : '') + 'sort_by=' + sort;
    var filter_url = coll + '?' + (option_name ? option_name + '&' : '') + 'sort_by=' + sort;

    window.history.pushState({}, null, filter_url);
    filter_update(url);
}


function filter_update(url) {
    fetch(url)
    .then(response => response.text())
    .then(infoData => {
        var productsSection = $(infoData).find('.collection-product-wrap'); // Fetch products + pagination
        $('.collection-product-wrap').replaceWith(productsSection); // Replace full section
    });
}



function filterActive(e,el){
    $(el).next().slideToggle(); 
    $(el).toggleClass('inactive');
}